import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { VeilleInformatiqueParams, VeilleInformatiqueResponse } from "./types";

async function runVeilleInformatique(
  params: VeilleInformatiqueParams
): Promise<VeilleInformatiqueResponse> {
  const response = await fetchClient<VeilleInformatiqueResponse>(
    "/core/media-scout/run_informatique/",
    { method: "POST", body: params }
  );

  if (response.error || !response.data) {
    const detail =
      response.error?.detail ??
      response.error?.message ??
      "Erreur lors de l'exécution de la veille informatique.";
    throw new Error(detail);
  }

  if (response.data.status === "error") {
    throw new Error("Erreur lors de l'exécution de la veille informatique.");
  }

  return response.data;
}

export function useRunVeilleInformatique() {
  return useMutation<VeilleInformatiqueResponse, Error, VeilleInformatiqueParams>({
    mutationFn: runVeilleInformatique,
  });
}
